module.exports = __webpack_public_path__ + "static/media/Colette Queen 2-Drawer Bed Base 155x205_Burnt Orange.6d0ecf70.png";